import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FirstVideo from 'views/LearnMore/FirstVideo';
import SecondVideo from 'views/LearnMore/SecondVideo';
import { ApplicationState } from 'store/rootReducer';
import { connect } from 'react-redux';
import DataDrivenMockServicesVideo from './DataDrivenMockServicesVideo';
import ReadyToMockCard from './ReadyToMockCard';
import Card from 'react-bootstrap/Card';
import BzmIcon from '../../components/icons/BzmIcon';

const mapStateToProps = ({ blazeUserConfig }: ApplicationState) => ({
  blazeUserConfig: blazeUserConfig.blazeUserConfig,
});

class LearnMore extends Component<MapToStateProps> {
  render = () => {
    return (
      <div className="container-fluid">
        {/* Ready To Mock? */}
        <ReadyToMockCard compact={false} />

        {/* Learn About Virtual Services */}
        <Card className={'p-7'}>
          <Row className={'mb-8'}>
            <Col lg="2">
              <h1 className={'text-uppercase'}>Learn about Virtual Services</h1>
            </Col>

            <Col lg="6">
              <h2>See How to Create and Run Virtual Services in 2 Minutes</h2>
              <div className="embed-responsive embed-responsive-16by9">{FirstVideo()}</div>
            </Col>

            <Col lg="4">
              <div className={'mb-8'}>
                <h2>Essential Topics</h2>
                <div className="font-size-xlg mb-3">
                  <BzmIcon variant={'icon-bzm-file-document'} />
                  <a className={'font-weight-semi-bold'} href="#" title="link">
                    {' '}
                    What are Virtual Services and Transactions?
                  </a>
                  <br />
                </div>
                <div className={'font-size-xlg mb-3'}>
                  <BzmIcon variant={'icon-bzm-file-document'} className={'pt-5'} />
                  <a className={'font-weight-semi-bold'} href="#" title="link">
                    {' '}
                    Create your First Virtual Service
                  </a>
                </div>
              </div>

              <div className={'mb-8'}>
                <h2>Tutorials</h2>
                <div className={'font-size-xlg mb-3'}>
                  <BzmIcon variant={'icon-bzm-file-document'} />
                  <a className={'font-weight-semi-bold'} href="#" title="link">
                    {' '}
                    Step-by-Step Tutorial
                  </a>
                  <br />
                </div>

                <div className={'font-size-xlg mb-3'}>
                  <BzmIcon variant={'icon-bzm-file-document'} />
                  <a className={'font-weight-semi-bold'} href="#" title="link">
                    {' '}
                    Virtualize AWS S3 Service for Testing
                  </a>
                  <br />
                </div>

                <div className={'font-size-xlg mb-3'}>
                  <BzmIcon variant={'icon-bzm-file-document'} />
                  <a className={'font-weight-semi-bold'} href="#" title="link">
                    {' '}
                    Create Virtual Services from Taurus Script
                  </a>
                  <br />
                </div>
              </div>
            </Col>
          </Row>

          <Row className={'mb-0'}>
            <Col lg="10" className={'offset-lg-2'}>
              <h2>Getting Started</h2>
              <div className="banner mb-0">
                <Row className="row">
                  <Col className="col-lg">
                    <div className="banner-item">
                      <BzmIcon variant={'icon-bzm-success'} className={'banner-item-image'} />
                      <div className="banner-item-content">
                        <h2 className="banner-item-title">Create</h2>
                        <p className="mb-3">
                          Create Virtual Services <br />
                          and add Transactions
                        </p>
                        <p>
                          <a className={'font-weight-semi-bold'} href="#">
                            Learn More
                          </a>
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col className="col-lg">
                    <div className="banner-item">
                      <BzmIcon variant={'icon-bzm-play-run'} className={'banner-item-image'} />
                      <div className="banner-item-content">
                        <h2 className="banner-item-title">Run</h2>
                        <p>
                          Start the Virtual Services <br />
                          and connect your app
                        </p>
                        <p className="mb-3">
                          <a className={'font-weight-semi-bold'} href="#">
                            Learn More
                          </a>
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col className="col-lg">
                    <div className="banner-item">
                      <BzmIcon variant={'icon-bzm-task-test'} className={'banner-item-image'} />
                      <div className="banner-item-content">
                        <h2 className="banner-item-title">Test</h2>
                        <p>
                          Update tests to run <br />
                          against the Virtual Services
                        </p>
                        <p className="mb-3">
                          <a className={'font-weight-semi-bold'} href="#">
                            Learn More
                          </a>
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Card>
        {/* ./Learn About Virtual Services */}

        {/* Data Driven Virtual Services */}
        <Card className={'p-7'}>
          <Row>
            <Col lg={'2'}>
              <h1 className={'text-uppercase'}>Introducing Data-Driven Virtual Services</h1>
            </Col>

            <Col lg={'6'}>
              <h2>Create data-driven Virtual Services in 2 minutes</h2>
              <div className="embed-responsive embed-responsive-16by9">{DataDrivenMockServicesVideo()}</div>
            </Col>

            <Col lg="4">
              <div className={'mb-8'}>
                <h2>Essential Topics</h2>
                <div className="font-size-xlg mb-3">
                  <BzmIcon variant={'icon-bzm-file-document'} />
                  <a
                    target="_blank"
                    style={{ fontWeight: 600 }}
                    href="https://guide.blazemeter.com/hc/en-us/articles/4413167202065-Using-Test-Data-With-Mock-Services-Using-Test-Data-With-Mock-Services"
                    title="link"
                    rel="noreferrer"
                  >
                    {' '}
                    How to create data-driven Virtual Services
                  </a>
                  <br />
                </div>
              </div>
            </Col>
          </Row>
        </Card>
        {/* ./Data Driven Virtual Services */}

        {/* Continuous Testing with BlazeMeter */}
        <Card className={'p-7'}>
          <Row>
            <Col lg={'2'}>
              <h1 className={'text-uppercase'}>Continuous Testing with BlazeMeter</h1>
            </Col>

            <Col lg={'6'}>
              <h2>The BlazeMeter Continuous Testing Platform in 3 Minutes</h2>
              <div className="embed-responsive embed-responsive-16by9">{SecondVideo()}</div>
            </Col>
          </Row>
        </Card>
        {/* ./Continuous Testing with BlazeMeter */}
      </div>
    );
  };
}

type MapToStateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(LearnMore);
